__webpack_require__.p = "https://public.instacover.ai/assets/crossroad/_next/";